import Axios from 'axios'
import { Button, Col, Modal, Row } from "antd";
import { User } from "authing-js-sdk";
import React, { FC, useCallback, useEffect, useState } from "react";
import { BindEmail } from "./BindEmail";
import { BindPhone } from "./BindPhone";
import styles from "./styles.module.less";
import { UpdateEmail } from "./UpdateEmail";
import { UpdatePhone } from "./UpdatePhone";
import { useTranslation } from "react-i18next";
import { ConfigCard } from "@/components/ConfigCard";
import { IconFont } from "@/components/IconFont";
import classNames from "classnames";
import { useMediaSize } from "@/hooks/useMediaSize";
import { RightOutlined } from "@ant-design/icons";

export const UserPageConnection: FC = () => {
  const [user, setUser] = useState(window.__user__);
  const [canEditMailbox, setCanEditMailbox] = useState<boolean>(false) // 邮箱是否可编辑，默认不可编辑
  const [canEditPhone, setCanEditPhone] = useState<boolean>(false) // 手机号是否可编辑，默认不可编辑
  const { t } = useTranslation();
  const updateUser = (user: User) => {
    setUser(user);
    window.__user__ = user;
  };

  const { isPhoneMedia } = useMediaSize();

  const [bindPhoneVisible, setBindPhoneVisible] = useState(false);
  const [updatePhoneVisible, setUpdatePhoneVisible] = useState(false);
  const renderBindPhone = () => (
    <BindPhone
      visible={bindPhoneVisible}
      onOk={(user) => {
        setBindPhoneVisible(false);
        updateUser(user);
      }}
      onCancel={() => setBindPhoneVisible(false)}
    />
  );
  const renderUpdatePhone = () =>
    user && (
      <UpdatePhone
        user={user}
        visible={updatePhoneVisible}
        onOk={(user) => {
          setUpdatePhoneVisible(false);
          updateUser(user);
        }}
        onCancel={() => setUpdatePhoneVisible(false)}
      />
    );

  const [bindEmailVisible, setBindEmailVisible] = useState(false);
  const [updateEmailVisible, setUpdateEmailVisible] = useState(false);
  const renderBindEmail = () => (
    <BindEmail
      visible={bindEmailVisible}
      onOk={(user) => {
        setBindEmailVisible(false);
        updateUser(user);
      }}
      onCancel={() => setBindEmailVisible(false)}
    />
  );
  const renderUpdateEmail = () =>
    user && (
      <UpdateEmail
        user={user}
        visible={updateEmailVisible}
        onOk={(user) => {
          setUpdateEmailVisible(false);
          updateUser(user);
        }}
        onCancel={() => setUpdateEmailVisible(false)}
      />
    );

  const fetchUdfPowerAndBasicFields = useCallback(async () => {
    const { data } = await Axios.post("/api/v2/udfs/all", {
      targetType: "USER",
    });
    const { accessControl } = data.find((item: any) => item.key === "phone")
    const { accessControl: accessControlEmail } = data.find((item: any) => item.key === "email")
    setCanEditPhone(accessControl)
    setCanEditMailbox(accessControlEmail)
  }, [setCanEditMailbox, setCanEditPhone])

  useEffect(() => {
    fetchUdfPowerAndBasicFields()
  }, [fetchUdfPowerAndBasicFields])

  const items = [
    {
      key: "email",
      label: t("common.email"),
      value: user?.email,
      icon: "authing-youxiang",
      onBind: () => setBindEmailVisible(true),
      onUpdate: () => setUpdateEmailVisible(true),
      onUnbind: () =>
        Modal.confirm({
          title: t("login.confirmUnbindEmail"),
          okCancel: true,
          onOk: async () => {
            const user = await window.__authing__.unbindEmail();
            updateUser(user);
          },
        }),
    },
    {
      key: "phone",
      label: t("common.phoneNumber"),
      value: user?.phone,
      icon: "authing-phone",
      onBind: () => setBindPhoneVisible(true),
      onUpdate: () => setUpdatePhoneVisible(true),
      onUnbind: () =>
        Modal.confirm({
          title: t("login.confirmUnbinPhont"),
          okCancel: true,
          onOk: async () => {
            const user = await window.__authing__.unbindPhone();
            updateUser(user);
          },
        }),
    },
  ];


  const getCanEdit = (key: string) => {
    if (key === "email") {
      return canEditMailbox
    }
    if (key === 'phone') {
      return canEditPhone
    }
  }

  const defActionNullValue = useCallback((item: any) => {

    if (getCanEdit(item.key)) {
      return (<Button
        icon={<IconFont type="authing-link1" style={{ fontSize: 16, marginRight: 6 }} />}
        type="link"
        onClick={item.onBind}
      >
        {t("common.bind")}
      </Button>)
    } else {
      return (<span style={{ padding: "4px 15px", border: "1px", display: "inline-block" }}>{t("login.notBind")}</span>
      )
    }
  }, [t, canEditMailbox, canEditPhone])


  const defAction = useCallback(
    (item: any) =>
      // 按钮显示 与 是否已填写，是否可修改，这两个状态有关
      item.value ? (
        <>
          {item.onUnbind && (
            <Button
              icon={<IconFont type="authing-link-unlink" style={{ fontSize: 16, marginRight: 6, color: "#FA6400" }} />}
              type="link"
              onClick={item.onUnbind}
              style={{
                color: "#333",
              }}
            >
              {t("login.releaseBind")}
            </Button>
          )}

          {getCanEdit(item.key) && <Button
            icon={<IconFont type="authing-bianji1" style={{ fontSize: 16, marginRight: 6 }} />}
            type="link"
            onClick={item.onUpdate}
          >
            {t("common.modify")}
          </Button>}
        </>
      ) : defActionNullValue(item),
    [t, defActionNullValue, getCanEdit]
  );

  const mediaAction = useCallback(
    (item) => {

      const canEdit = getCanEdit(item.key)
      if (item.value) {
        if (canEdit) {
          return (<div className={styles.action}>
            <span className={styles.value}>{item.value}</span>
            <RightOutlined />
          </div>)
        } else {
          return (<div className={styles.action}>
            <span >{item.value}</span>
          </div>)
        }
      } else {
        if (!canEdit) {
          return (<div className={styles.action}>
            <span>{t("login.notBind")}</span>
          </div>)
        } else {
          return (<div className={styles.action}>
            <span>{t("user.unBind")}</span>
            <RightOutlined />
          </div>)
        }
      }
    },
    [t, getCanEdit]
  );

  const mediaOnClick = useCallback((item) => {
    if (item.value) {
      if (getCanEdit(item.key)) {
        return item.onUpdate;
      } else {
        return undefined;
      }
    } else {
      if (getCanEdit(item.key)) {
        return item.onBind
      } else {
        return undefined
      }
    }
  }, [getCanEdit]);

  return (
    <ConfigCard title={t("login.accBind")} extra={null}>
      <div className={styles.connection}>
        {renderBindPhone()}
        {renderUpdatePhone()}
        {renderBindEmail()}
        {renderUpdateEmail()}

        <Row>
          {items.map((item) => (
            <Col key={item.key} span={24} className={styles.row} onClick={isPhoneMedia ? mediaOnClick(item) : undefined}>
              {/* <Icon icon={item.key} active={!!item.value} /> */}
              <div
                className={classNames(styles.iconContent, {
                  [styles.active]: !!item.value,
                })}
              >
                <IconFont type={item.icon} />
              </div>
              <span className={styles.label}>{item.label}</span>
              {!isPhoneMedia && (
                <>
                  {item.value && ":"}
                  <span className={styles.value}>{item.value}</span>
                </>
              )}

              <div style={{ flex: 1 }}></div>
              {!isPhoneMedia ? defAction(item) : mediaAction(item)}
            </Col>
          ))}
        </Row>
      </div>
    </ConfigCard >
  );
};
